import React from "react";
import { useSelector } from "react-redux";

import Background from "../Global/Background";
import Image from "../Global/Image";
import Video from "../Global/Video";

const GalleryMediaModalItem = (props) => {
  const { data, itemIndex } = props;

  const storeCurrentIndex = useSelector((state) => state.gallery.currentIndex);

  if (!data) return null;

  return (
    <React.Fragment>
      {data.youtube && (
        <div
          className={`gallery-modal-main-item d-flex justify-content-center align-items-center`}
        >
          <Background
            className={`position-relative brand-background-grey brand-hero-wrapper-video ratio ratio-16x9 ratio-lg-21x9`}
            sm="0x500"
            md="0x900"
            lg="0x900"
            src={data.image.filename}
          >
            {itemIndex === storeCurrentIndex && (
              <Video
                containerClassName="w-100 h-100"
                videoYoutubeUrl={data.youtube}
                light={true}
              />
            )}
          </Background>
        </div>
      )}

      {!data.youtube && data?.video?.vimeo_raw && (
        <div
          className={`gallery-modal-main-item d-flex justify-content-center align-items-center`}
        >
          <Background
            className={`position-relative brand-background-grey ratio ratio-16x9 ratio-lg-21x9`}
            sm="0x500"
            md="0x900"
            lg="0x900"
            src={data.image.filename}
          >
            {itemIndex === storeCurrentIndex && (
              <Video video={data.video} light={true} />
            )}
          </Background>
        </div>
      )}

      {!data?.video?.vimeo_raw && !data.youtube && data.image && (
        <div
          className={`gallery-modal-main-item d-flex justify-content-center align-items-center`}
        >
          <Image
            src={data?.image?.filename}
            alt={data?.image?.alt}
            sm="0x500"
            md="0x900"
            lg="0x900"
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default GalleryMediaModalItem;
